import { Component, OnInit } from '@angular/core';
import { RegionalAdminService } from 'src/app/control-panel/services/regional-admins/regional-admins.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'app-administrators-panel',
  templateUrl: './administrators-panel.component.html',
  styleUrls: ['./administrators-panel.component.scss'],
})

/**
 * Administrators panel organism
 */
export class AdministratorsPanelComponent implements OnInit {
  labels = {
    administratorsList: 'administrators-list',
    regionsWithoutRegional: 'regions-without-regional',
    regionWithoutRegional: 'region-without-regional',
  };
  voidRegions!: any[];
  hasAdvice = false;
  singleRegion!: boolean;
  lastRegion = true;
  loading = false;

  /**
   * @constructor
   */
  constructor(
    private translationService: TranslationService,
    public regionalAdminService: RegionalAdminService
  ) {}

  /**
   * on init
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
    this.regionalAdminService.getRegionalAdminCount();
    this.pullVoidRegions();
  }

  /**
   * Check whether index is the last one
   * @param {number} index
   * @return {boolean}
   */
  public isLast(index: number): boolean {
    return this.voidRegions.length > 0 && index === this.voidRegions.length - 1;
  }

  /**
   * Gets Regions
   */
  pullVoidRegions() {
    this.regionalAdminService.voidRegions$.subscribe((item) => {
      this.voidRegions = item;
      this.hasAdvice =
        this.voidRegions && this.voidRegions.length > 0 ? true : false;
      this.singleRegion =
        this.voidRegions && this.voidRegions.length === 1 ? true : false;
      this.loading = false;
    });
  }
}
